import * as React from 'react'
import { FC, ReactNode, useEffect } from 'react'
import { useMount } from 'react-use'
import { compact } from 'lodash'
import { AccordionBodyProps } from '@organisms/Accordion'
import EditModal from '@templates/EditModal'
import DeleteButton from '@templates/DeleteButton'
import {
  useDeleteRiskMapPositionMutation,
  useGetRiskMapPositionQuery,
} from '@services/riskMapJobPositions'
import PositionAndDangersModal from '@modals/PositionAndDangersModal'
import Table, { Column } from '@atoms/Table'
import { FooterWrapper } from './styled'

type TableItem = {
  key: string
  kind: ReactNode
  dangerous: ReactNode
  workPlace: ReactNode
  object: ReactNode
}

const COLUMNS: Column[] = [
  {
    title: 'Вид',
    dataIndex: 'kind',
  },
  {
    title: 'Опасность / опасное событие',
    dataIndex: 'dangerous',
  },
  {
    title: 'Работы / Место / Авария',
    dataIndex: 'workPlace',
  },
  {
    title: 'Объект возникновения опасности',
    dataIndex: 'object',
  },
]

type Props = {
  id: number
} & AccordionBodyProps

const Body: FC<Props> = ({ id, onChangeSize, toggleLoading }) => {
  const { data, isSuccess } = useGetRiskMapPositionQuery(id)
  const [deletePosition, deleteData] = useDeleteRiskMapPositionMutation()

  useMount(() => {
    toggleLoading(true)
  })

  useEffect(() => {
    if (isSuccess) {
      toggleLoading(false)
      onChangeSize()
    }
  }, [isSuccess])

  if (!data) return null

  const dataItems: TableItem[] = data.riskMapJobPositionDangers.map(
    ({ '@id': idVal, hazard, event, object, workPlace, kind }) => ({
      key: idVal,
      kind: kind?.value || '',
      dangerous: compact([hazard?.value, event?.value]).join(' / '),
      workPlace: workPlace?.value || '',
      object: object?.value || '',
    })
  )

  return (
    <>
      <Table columns={COLUMNS} data={dataItems} />
      <FooterWrapper>
        <EditModal
          ModalContent={PositionAndDangersModal}
          modalProps={{ riskMapPosition: data }}
          withoutCloseOnOutsideClick
        />
        <DeleteButton
          {...deleteData}
          onClick={() => {
            deletePosition(id)
          }}
        />
      </FooterWrapper>
    </>
  )
}

export default Body
